module.exports = function isNil(x) {
  return x === null || x === void 0;
};